import React, { useState } from 'react';
import { Modal, Select, Alert } from 'antd';
import { SettingOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

const estatusOpciones = [
  { value: 1, label: 'Estatus 1 - Orden creada, pendiente de validación' },
  { value: 2, label: 'Estatus 2 - Orden validada, lista para solicitar factura' },
  { value: 3, label: 'Estatus 3 - Factura solicitada a proveedor' },
  { value: 4, label: 'Estatus 4 - Factura recibida, pendiente de validación' },
  { value: 5, label: 'Estatus 5 - Factura validada, pendiente de pago' },
  { value: 6, label: 'Estatus 6 - Factura pagada, en espera de complemento' },
  { value: 7, label: 'Estatus 7 - Proceso completado' }
];

export default function ModalAdminStatusOverride({
  visible,
  onClose,
  onConfirm,
  loading,
  estatusActual
}) {
  const [estatusSeleccionado, setEstatusSeleccionado] = useState(null);
  const [brincar, setBrincar] = useState(null);

  const handleOk = () => {
    if (estatusSeleccionado) {
      onConfirm(estatusSeleccionado, brincar);
    }
  };

  const handleCancel = () => {
    setEstatusSeleccionado(null);
    setBrincar(null);
    onClose();
  };

  const estatusLabel = estatusOpciones.find(e => e.value === estatusActual)?.label || `${estatusActual}`;

  return (
    <Modal
      title={
        <span>
          <SettingOutlined style={{ marginRight: 8 }} />
          Admin Status Override
        </span>
      }
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Aplicar Cambio"
      cancelText="Cancelar"
      okButtonProps={{ disabled: !estatusSeleccionado, icon: <CheckCircleOutlined /> }}
      cancelButtonProps={{ icon: <CloseCircleOutlined />, danger: true }}
      width={600}
      className="pagos-v2-modal"
    >
      <Alert
        description={`${estatusLabel}`}
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>
          Seleccione el nuevo estatus:
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder="Seleccione un estatus"
          value={estatusSeleccionado}
          onChange={setEstatusSeleccionado}
          size="large"
        >
          {estatusOpciones.map(opcion => (
            <Option key={opcion.value} value={opcion.value}>
              {opcion.label}
            </Option>
          ))}
        </Select>
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: 8 }}>
          Brincar (opcional):
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder="Seleccione un número para brincar (opcional)"
          value={brincar}
          onChange={setBrincar}
          size="large"
          allowClear
        >
          {[1, 2, 3, 4, 5, 6, 7].map(num => (
            <Option key={num} value={num}>
              {num}
            </Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
}
